import { Tools } from 'hanzi-vue-package'

const app = {
      state: {
            data: Tools.cache.get('status') || null,
            name: '',
            headimg: '',
            is_show: false,
            dialogVisible: false,
            sin_login: false,/*登录*/
            register: false,/*注册*/
            forget: false,/*忘记密码*/
            pay: false,/*充值*/
            money: 0,/*个人金额*/
            refresh: '',/*局不刷新*/
            time: '',/*时间*/
            weChat: false,/*微信充值*/
            alPay: false,/*支付宝充值*/
            goPay: true,
            donw_url: null,
            registration: false,
            pay_type: 0,
            nunm: 0,
            pay_course_id: '', // 正在支付的课程
            pay_course_gift: false, // 正在支付课程是否有礼品
            mold: {
                  al_url: null,
                  wechat_url: null,
                  amount: null
            },
            msg: false
      },
      mutations: {
            GET_INFO: state => {
                  state.data = JSON.parse(Tools.cache.get('status'))
                  //    state.name = data.username // 用户名
                  //    state.headimg = data.headimg // 用户头像
            },
            GET_MONEY: state => {

            },
            GET_LIST: (state) => {
                  var that = this;
                  if (!JSON.parse(tools.cache.get('status'))) {
                        return
                  }
                  var ajaxData = {};
                  Tools.ajax({
                        url: '/api/user/messages/unread/num',
                        ajaxData: ajaxData,
                        successFun: function (res) {
                              state.nunm = res.data.num;
                        },
                        errorFun: function (error_data, status, headers, error_obj) {
                              tools.alert.error(error_data.error_msg);
                        },
                        type: 'GET'
                  });
            },
      },
      actions: {
            updateInfo({ commit }) {
                  commit('GET_INFO')
            }
      }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js